import { useQuery } from "@tanstack/react-query";
import { api, type Group, type LogGroup } from "./api";
import { useSession } from "./session";

export function useGroups() {
  const { tenant } = useSession();
  return useQuery({
    queryKey: ["groups", tenant],
    queryFn: () => api<{ groups: Group[] }>("/v1/groups").then((r) => r.groups),
  });
}

export function useLogGroups() {
  const { tenant } = useSession();
  return useQuery({
    queryKey: ["log-groups", tenant],
    queryFn: () => api<{ log_groups: LogGroup[] }>("/v1/log-groups").then((r) => r.log_groups),
  });
}
